import {useFormatNumber} from 'platform/locale';

import {isNil} from 'ramda';

import type {Nullish} from 'shared/web';

export function useFormatReportPercentage() {
  const formatNumber = useFormatNumber();
  return (percentage: number | Nullish) => {
    const formatted = formatNumber(percentage, 2);
    return isNil(formatted) ? '—' : `${formatted} %`;
  };
}
